import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response ,Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

@Component({
  selector: 'app-chatusers',
  templateUrl: './chatusers.component.html',
  styleUrls: ['./chatusers.component.css'],
   providers: [HelperService] 
})
export class ChatusersComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
 from;
 to;
 datas:any=[];
 dtOptions: DataTables.Settings = {};
 dtTrigger: Subject<any> = new Subject();
  dtElement: DataTableDirective;
notify;
 live_users;
 user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});

 constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router) {
  	
  		activatedRouter.queryParams.subscribe(params => {
    this.from = params['from'];
    this.to = params['to'];
});
     
  		
  }


  ngOnInit() {
  	this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/chat/live/students',{ headers: this.headers })
  
    .subscribe(data => {
     // arr=JSON.parse(data);
      this.datas = JSON.parse(data['_body']);
      this.dtTrigger.next();
               
    });
  }
  backbtn(){
    window.history.back();
  }
  

}



// WEBPACK FOOTER //
// ./src/app/chatusers/chatusers.component.ts